import { BODY_TEXT, GRAY_ALTERNATIVE } from 'src/global/theme/colors';
import { makeStyles } from 'tss-react/mui';

export const styles = makeStyles()(() => {
  return {
    root: {
      fontSize: 16,
      lineHeight: '22px',
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      padding: '24px 0',
      cursor: 'pointer',
      '&:nth-of-type(odd)': {
        backgroundColor: GRAY_ALTERNATIVE
      }
    },
    tableRow: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center'
    },
    priceContainer: {
      display: 'flex',
      flexDirection: 'column',
      marginLeft: "8px",
    },
    dateContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      minWidth: 0
    },
    showLink: {
      textDecoration: 'none',
      color: BODY_TEXT
    },
    commerceIcon: {
      borderRadius: '50%'
    }
  };
});
